import ApiService from "@/services/api.service"

/// *** Cashdesk Service *** ///

export const CashdeskService = {
  getData() {
    return ApiService.get("cashdesk/settings")
  },
  saveSettings(settings) {
    return ApiService.post(`cashdesk/settings`, { settings })
  },
  openShift() {
    return ApiService.post(`cashdesk/shift/open`)
  },
  closeShift() {
    return ApiService.post(`cashdesk/shift/close`)
  },
  createXReport() {
    return ApiService.post(`cashdesk/xreport`)
  },
  depositMoney(amount) {
    return ApiService.post(`cashdesk/operations/deposit`, { amount })
  },
  withdrawMoney(amount) {
    return ApiService.post(`cashdesk/operations/withdraw`, { amount })
  },
  webkassaData(type) {
    return ApiService.get(`webkassa/data/${type}`)
  },
  aqsiData(type) {
    return ApiService.get(`aqsi/data/${type}`)
  },
  newcasData(type) {
    return ApiService.get(`newcas/data/${type}`)
  },
  async getShiftData(vendor) {
    try {
      if(vendor === 'webkassa') {
        const res = await CashdeskService.webkassaData('shifts')
        return res.data
      }
      if(vendor === 'aqsi') {
        const res = await CashdeskService.aqsiData('shifts')
        return res.data.rows
      }
      if(vendor === 'newcas') {
        const res = await CashdeskService.newcasData('shifts')
        return res.data
      }
    } catch (error) {
      return []
    }

  },
  getDashboard(params) {
    return ApiService.get(`cashregister/dashboard`, params)
  },
  getDaily(params) {
    return ApiService.get(`cashregister/day`, params)
  }
}
